/* A versão que aparece num relatório de erro.

   `__COMMIT__` é injetado pelo Vite a partir do commit do build. Sem ele,
   um print de erro não diz qual código estava rodando — e num app que
   atualiza sozinho a resposta "qual versão você está usando?" nunca vem
   certa de quem está reportando. */
declare const __COMMIT__: string;

export const APP_VERSION: string =
  typeof __COMMIT__ === "string" && __COMMIT__ ? __COMMIT__ : "dev";
